module.exports = __webpack_public_path__ + "static/media/information-background.d0aad1b3.png";